var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticStyle:{"border":"3px solid"},attrs:{"id":"BtnDemo","type":"is-primary animated-bg","rounded":""},on:{"click":_vm.showModalDemoForm}},[_vm._v(_vm._s(_vm.$t("btnlabel")))])
}
var staticRenderFns = []

export { render, staticRenderFns }